<template>
    <div>
        <div class="card">
            <div class="card-body">
                <button v-loading="data_loading.comments" :disabled="data_loading.comments" v-if="$hasPermission('requests.comments.show')" class="btn mb-2 mr-1" v-bind:class="{'btn-light': !filter_comments, 'btn-light': !filter_comments, 'text-dark': !filter_comments, 'btn-primary': filter_comments}" @click="toggleFilterComments">Комментарии</button>
                <button v-loading="data_loading.sms_messages" :disabled="data_loading.sms_messages" v-if="$hasPermission('requests.sms.show')" class="btn mb-2 mr-1" v-bind:class="{'btn-light': !filter_sms_messages, 'btn-light': !filter_sms_messages, 'text-dark': !filter_sms_messages, 'btn-primary': filter_sms_messages}" @click="toggleFilterSmsMessage">СМС</button>
                <button v-loading="data_loading.reminders" :disabled="data_loading.reminders" v-if="$hasPermission('requests.reminders.show')" class="btn mb-2 mr-1" v-bind:class="{'btn-light': !filter_reminders, 'btn-light': !filter_reminders, 'text-dark': !filter_reminders, 'btn-primary': filter_reminders}" @click="toggleFilterReminders">Напоминания</button>
                <button v-loading="data_loading.calls" :disabled="data_loading.calls" v-if="$hasPermission('requests.calls.show')" class="btn mb-2 mr-1" v-bind:class="{'btn-light': !filter_calls, 'btn-light': !filter_calls, 'text-dark': !filter_calls, 'btn-primary': filter_calls}" @click="toggleFilterCalls">Звонки</button>
                <button v-if="data_groups.comments_by_hash_request && Object.keys(data_groups.comments_by_hash_request).length" @click.prevent="visibleModalCommentsByHash = true" class="btn btn-primary mb-2 mr-1 float-right">Комментарии других салонов</button>
                <div class="request-action-list-wrap mt-4">
                    <ul class="timeline mb-0 request-action-list">
                        <li class="timeline-item request-action-item" v-for="item in watch_list">
                            <div v-if="item.type === 'init'">
                                <div class="row">
                                    <div class="col-sm-6"></div>
                                    <div class="col-sm-6">
                                        <div class="float-sm-right request-action-item-right pr-2">
                                            <span class="small">{{item.data.created_at}}</span>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <strong>Создана заявка</strong>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.type === 'source_comment'">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <strong><span class="text-muted small">комментарий источника</span></strong>
                                    </div>
                                    <div class="col-12">
                                        <p class="text-pre-wrap">{{item.data.text}}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.type === 'comment'">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <strong><span class="text-muted small">комментарий</span> <span class="badge badge-primary">{{item.data.user.name}}</span></strong>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="float-sm-right request-action-item-right pr-2">
                                            <span class="small">{{item.data.created_at}}</span>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <p class="text-pre-wrap">{{item.data.text}}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.type === 'sms_message'">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <strong><span class="text-muted small">СМС</span> <span class="badge badge-primary">{{item.data.user.name}}</span></strong>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="float-sm-right request-action-item-right pr-2">
                                            <span v-if="item.data.status === 'error'" class="small text-danger">Ошибка</span>
                                            <span class="small">{{item.data.created_at}}</span>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <p class="text-pre-wrap">{{item.data.text}}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.type === 'reminder'">
                                <RequestHistoryActionReminder :item="item"/>
                            </div>
                            <div v-if="item.type === 'call'">
                                <RequestHistoryActionCall :item="item"/>
                            </div>
                            <div v-if="item.type === 'appeal'">
                                <RequestHistoryActionAppeal :item="item"/>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <el-dialog v-if="data_groups.comments_by_hash_request" title="Комментарии других салонов" :visible.sync="visibleModalCommentsByHash" width="450px" :append-to-body="true">
            <el-tabs type="card">
            <template v-for="(p_comments, p_id) in data_groups.comments_by_hash_request">
                    <el-tab-pane :label="PlatformHelper.get(p_id).name">
                        <template v-for="comments in p_comments">
                            <el-timeline>
                                <el-timeline-item
                                    v-for="c in comments"
                                    :key="c.id"
                                    :timestamp="c.created_at">
                                    {{c.text}}
                                </el-timeline-item>
                            </el-timeline>
                        </template>
                    </el-tab-pane>
            </template>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
    import {Edit2Icon, XIcon} from 'vue-feather-icons';
    import RequestHistoryActionReminder from "./history_actions/RequestHistoryActionReminder";
    import RequestHistoryActionCall from "./history_actions/RequestHistoryActionCall";
    import RequestHistoryActionAppeal from "./history_actions/RequestHistoryActionAppeal";
    import PlatformHelper from "../../helpers/platform";
    import appeals from "../../helpers/appeals";

    // TODO автоподтягивание статусов смсок
    export default {
        name: "RequestHistoryActions",
        components: {RequestHistoryActionCall, RequestHistoryActionReminder, RequestHistoryActionAppeal, Edit2Icon,XIcon},
        props: ['request'],
        data: () => ({
            data_groups: {
                comments: [],
                comments_by_hash_request: [],
                sms_messages: [],
                reminders: [],
                calls: [],
                appeals: [],    // обращения заявки (звонки и лиды): запись на каждое, строка самого звонка в calls не меняется
            },
            data_loading: {
                comments: false,
                sms_messages: false,
                reminders: false,
                calls: false,
            },
            filter_comments: false,
            filter_sms_messages: false,
            filter_reminders: false,
            filter_type: null,
            filter_calls: null,

            visibleModalCommentsByHash: false,
        }),
        mounted() {
            this.fetchData();
            let self = this;
            this.$bus.$on('request.' + this.request.id + '.comment:create', () => {self.fetchData('comments')})
            this.$bus.$on('request.' + this.request.id + '.sms_message:create', () => {self.fetchData('sms_messages')})
            this.$bus.$on('request.' + this.request.id + '.reminder:create', () => {self.fetchData('reminders')})
            this.$bus.$on('request.' + this.request.id + '.reminder:done', () => {self.fetchData('reminders')})
            // Обращения пишет сервер, из интерфейса их не создать: событие для тех, кто захочет обновить записи обращений
            this.$bus.$on('request.' + this.request.id + '.appeal:refresh', () => {self.fetchData('appeals')})
        },
        beforeDestroy() {
            this.$bus.$off([
                'request.' + this.request.id + '.comment:create',
                'request.' + this.request.id + '.sms_message:create',
                'request.' + this.request.id + '.reminder:create',
                'request.' + this.request.id + '.reminder:done',
                'request.' + this.request.id + '.appeal:refresh',
            ]);
        },
        computed: {
            PlatformHelper() {
                return PlatformHelper
            },
            watch_list() {
                let self = this;
                if (this.filter_type) {
                    let list = _.clone(this.data_list_sorted);
                    return list.filter(function (item) {
                        return item.type === self.filter_type
                    });
                } else {
                    return this.data_list_sorted;
                }
            },
            data_list() {
                let data = [];

                this.data_groups.comments.forEach(function (comment) {
                    data.push({type: 'comment', data: comment})
                });
                this.data_groups.sms_messages.forEach(function (message) {
                    data.push({type: 'sms_message', data: message})
                });
                this.data_groups.reminders.forEach(function (reminder) {
                    data.push({type: 'reminder', data: reminder})
                });
                this.data_groups.calls.forEach(function (call) {
                    data.push({type: 'call', data: call})
                });
                this.data_groups.appeals.forEach(function (block) {
                    data.push({type: 'appeal', data: block})
                });
                if (this.request.source_comment) data.push({type: 'source_comment', data: {text: this.request.source_comment}});
                data.push({type: 'init', data: {created_at: this.request.created_at, text: "Создана заявка"}});
                return data;
            },
            data_list_sorted() {
                // При равном времени обращение звонка идёт сразу после своего звонка (его время совпадает со временем звонка),
                // а «Создана заявка» — самой нижней записью
                const tie_order = {appeal: 1, init: 2};
                return _.clone(this.data_list).sort(function (a, b) {
                    let a_field = a.data.created_at;
                    let b_field = b.data.created_at;

                    if (a.type === 'call') a_field = a.data.called_at;
                    if (b.type === 'call') b_field = b.data.called_at;
                    if (a.type === 'appeal') a_field = a.data.occurredAt;
                    if (b.type === 'appeal') b_field = b.data.occurredAt;

                    const diff = (new Date(b_field)) - (new Date(a_field));
                    if (diff === 0) return (tie_order[a.type] || 0) - (tie_order[b.type] || 0);
                    return diff;
                });
            },
        },
        methods: {
            fetchComments() {
                let self = this;
                if (!self.$hasPermission('requests.comments.show')) {
                    self.data_groups.comments = [];
                    return;
                }
                this.data_loading.comments = true;
                axios.get('/api/requests/' + this.request.id + '/comments')
                    .then(response => {
                        self.data_groups.comments = response.data
                        self.data_loading.comments = false;
                    });
            },
            fetchSmsMessages() {
                let self = this;
                if (!self.$hasPermission('requests.sms.show')) {
                    self.data_groups.sms_messages = [];
                    return;
                }
                this.data_loading.sms_messages = true;
                axios.get('/api/requests/' + this.request.id + '/sms_messages')
                    .then(response => {
                        self.data_groups.sms_messages = response.data;
                        self.data_loading.sms_messages = false;
                    });
            },
            fetchReminders() {
                let self = this;
                if (!self.$hasPermission('requests.reminders.show')) {
                    self.data_groups.reminders = [];
                    return;
                }
                this.data_loading.reminders = true;
                axios.get('/api/requests/' + this.request.id + '/reminders')
                    .then(response => {
                        self.data_groups.reminders = response.data;
                        self.data_loading.reminders = false;
                    });
            },
            fetchCalls() {
                let self = this;
                if (!self.$hasPermission('requests.calls.show')) {
                    self.data_groups.calls = [];
                    return;
                }
                this.data_loading.calls = true;
                axios.get('/api/requests/' + this.request.id + '/calls')
                    .then(response => {
                        self.data_groups.calls = response.data;
                        self.data_loading.calls = false;
                    });
            },
            fetchAppeals() {
                let self = this;
                // Обращения-звонки раскрывают звонки заявки, поэтому тем, кто звонки не видит, — только лиды
                const params = this.$hasPermission('requests.calls.show') ? {} : {channel: 'lead'};
                axios.get('/api/requests/' + this.request.id + '/appeals', {params: params})
                    .then(response => {
                        self.data_groups.appeals = appeals.appealBlocks(response.data);
                    })
                    // Обращения — дополнение к ленте: не получилось загрузить, лента остаётся как была
                    .catch(() => {
                        self.data_groups.appeals = [];
                    });
            },
            fetchCommentsByHash() {
                let self = this;
                if (!self.$hasPermission('requests.comments.show')) {
                    self.data_groups.comments_by_hash_request = [];
                    return;
                }
                axios.get('/api/requests/' + this.request.id + '/comments', {params: {byHash: 1}})
                    .then(response => {
                        self.data_groups.comments_by_hash_request = response.data
                    });
            },
            fetchData(only) {
                if (only) {
                    if (only === 'comments') this.fetchComments();
                    if (only === 'sms_messages') this.fetchSmsMessages();
                    if (only === 'reminders') this.fetchReminders();
                    if (only === 'calls') this.fetchCalls();
                    if (only === 'appeals') this.fetchAppeals();
                } else {
                    this.fetchComments();
                    this.fetchSmsMessages();
                    this.fetchReminders();
                    this.fetchCalls();
                    this.fetchAppeals();
                    this.fetchCommentsByHash();
                }
            },
            toggleFilterComments() {
                this.filter_sms_messages = false;
                this.filter_reminders = false;
                this.filter_calls = false;
                this.filter_comments = !this.filter_comments;
                this.filter_type = this.filter_comments ? 'comment' : null;
            },
            toggleFilterSmsMessage() {
                this.filter_comments = false;
                this.filter_reminders = false;
                this.filter_calls = false;
                this.filter_sms_messages = !this.filter_sms_messages;
                this.filter_type = this.filter_sms_messages ? 'sms_message' : null;
            },
            toggleFilterReminders() {
                this.filter_comments = false;
                this.filter_sms_messages = false;
                this.filter_calls = false;
                this.filter_reminders = !this.filter_reminders;
                this.filter_type = this.filter_reminders ? 'reminder' : null;
            },
            toggleFilterCalls() {
                this.filter_comments = false;
                this.filter_sms_messages = false;
                this.filter_reminders = false;
                this.filter_calls = !this.filter_calls;
                this.filter_type = this.filter_calls ? 'call' : null;
            }
        }
    }
</script>

<style scoped>
    .request-action-list-wrap {
        max-height: 600px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>
